module.exports = __webpack_public_path__ + "img/RankList-name.e067d12f.png";